<template>
    <div class="toggle" :class="{'disabled': disabled}" v-on:click="toggle">
        <input type="hidden" :name="type" value="true" />
        <div class="toggle__indicator" :class="{
            'toggle__indicator--active': active
        }"></div>
    </div>
</template>

<script>
export default {
    props: ["type", "disabled"],
    mounted() {
    },
    data() {
        return {
            active: false,
        }
    },
    mounted() {
        let cookie = this.getCookie('cookies-' + this.type);
        if (this.disabled) {
            this.active = true;
        } else {
            this.active = cookie && cookie !== "false";
        }
    },
    methods: {
        toggle: function () {
            if (this.disabled) {
                return;
            } else {
                this.active = !this.active;
                this.setCookie('cookies-' + this.type, this.active)
            }
        },
        getCookie: function (name) {
            if (document.cookie.includes(name)) {
                let cookieValue = document.cookie
                    .split('; ')
                    .find((row) => row.startsWith(name + '='))
                    ?.split('=')[1];
                return cookieValue;
            }
            
            return null;
        },
        setCookie: function (name, value) {
            var expires = "";
            var date = new Date();
            date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
            document.cookie = name + "=" + value + expires + "; path=/";
        }
    }
}
</script>

